import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

interface OrganisationTabsProps {
  orgId: string;
}

// Onglets de la section « Organisation » (menu unique) : Membres | Groupes.
// Les routes existantes sont conservees, seul l'acces est regroupe.
const OrganisationTabs: React.FC<OrganisationTabsProps> = ({ orgId }) => {
  const { t } = (useTranslation as any)('organisations');
  const { pathname } = useLocation();
  const tabs = [
    { key: 'members', href: `/organisations/${orgId}/members`, label: t('tabs.members') },
    { key: 'groups', href: `/organisations/${orgId}/groups`, label: t('tabs.groups') },
  ];
  return (
    <nav className="flex space-x-6 border-b border-border-1 mb-6" aria-label={t('tabs.ariaLabel') as string}>
      {tabs.map((tab) => {
        const active = pathname.startsWith(tab.href);
        return (
          <Link
            key={tab.key}
            to={tab.href}
            className={`pb-3 -mb-px text-sm font-medium border-b-2 transition-colors ${
              active
                ? 'border-accent-500 text-text-primary'
                : 'border-transparent text-text-tertiary hover:text-text-secondary hover:border-border-1'
            }`}
            aria-current={active ? 'page' : undefined}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default OrganisationTabs;
